import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { GridOptions } from 'ag-grid-community';
import _ from 'lodash';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/services/loading/loading.service';
import { IffShipmentDetailsService } from 'src/app/services/iff-shipment-details/iff-shipment-details.service';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'app-frt-comprehensive-report',
    templateUrl: './frt-comprehensive-report.component.html',
    styleUrls: ['./frt-comprehensive-report.component.css'],
    standalone: false
})
export class FrtComprehensiveReportComponent implements OnInit {

  frtComprehensiveFormGroup: UntypedFormGroup;
  resultsSubscription = new Subscription();
  public reportingYrList = [];
  reportingYr:number;
  reportingQtr: number=0;
  currrentYr :number=0;
  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 10,
    rowSelection: 'multiple',
    defaultColDef: {
      sortable: true,
      resizable: true,
      filter: 'agNumberColumnFilter',
      filterParams: {
        suppressAndOrCondition: false
      }
    },
    headerHeight: 50,
    cacheBlockSize: 25,
    domLayout: 'autoHeight',
    overlayLoadingTemplate:
      '<span class="ag-overlay-loading-center">Select the Reporting Year/Quarter to load report.</span>',
    overlayNoRowsTemplate:
      '<span>No results found. Please adjust your filters.</span>'
  };
  private gridApi;
  subArr = [];
  columnsDefs: any;
  rowData: any;
  rowData1: any;

  /**
   * @description defines the button renderer component to show the smartWay button based on the flag.
   */
  constructor(private shipmentDetailService: IffShipmentDetailsService,
    private fb: UntypedFormBuilder,
    private router: Router, private loader: LoadingService) {

  }

  /**
   * initializing the ag-grid
   * @param params
   */
  onGridReady(params: any) {
    params.api.sizeColumnsToFit();
    this.gridApi = params.api;
    this.gridApi.setDatasource(this.rowData);
  }

  /**
   * @description manipulates row data according to the desired results and generates columns dynamically by looping through rowData.
   */
  ngOnInit() {
    this.frtComprehensiveFormGroup = this.fb.group({
      reportingYrSelect: new UntypedFormControl('', Validators.required),
      reportingQtrSelect: new UntypedFormControl('')

    });
    this.currrentYr= new Date().getFullYear();
    this.reportingYrList.push({name:this.currrentYr, value:this.currrentYr})
    for(let i=1; i<7; i++){
      let previousYr = this.currrentYr-i;
      this.reportingYrList.push({name:previousYr, value:previousYr});
    }
  }
  getFRTCompresensiveDetails(){
    this.loader.show();
    this.resultsSubscription = this.shipmentDetailService.getFRTComprehensiveReport(this.reportingYr, this.reportingQtr).subscribe(res => {
     console.log ("res.length "+ res.length);
      if (res !== null && res !== undefined && res.length > 0) {
        this.rowData = res;
        this.columnsDefs = this.frtComprensivecolumnDefs;
        this.loader.hide();
      }else{
        this.rowData =null;
        this.loader.hide();
      }
    });
  }
  onReportYrChange(reportYr: number) {
    this.reportingYr=reportYr;
  }
  onReportQtrChange(reportQtr: number) {
    this.reportingQtr=reportQtr;
  }
  frtComprensivecolumnDefs=[
    {
      headerName: 'SCAC Code',
      field: 'scac',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'SCAC ',
      field: 'scacName',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'FAIC ',
      field: 'faicCode',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Agency',
      field: 'agencyBureauName',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Pro Bill Number',
      field: 'proBillNumber',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'BOL',
      field: 'bolNumber',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'GBL/CBL',
      field: 'gblcbl',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Move Type',
      field: 'moveType',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Pickup Date',
      field: 'pickupDate',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Delivery Date',
      field: 'deliveryDate',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Origin',
      field: 'originStateCode',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Destination',
      field: 'destinationStateCode',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Last Name',
      field: 'employeeLastName',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Weight',
      field: 'weight',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Miles',
      field: 'miles',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Discount',
      field: 'discount',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Gross Amount',
      field: 'grossAmount',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Net Amount',
      field: 'netAmount',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Pass Thr amt',
      field: 'passThruAmount',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Total AF',
      field: 'totalIFF',
      filter: 'agTextColumnFilter',
      sortable: true
    }
  ];


  /**
   * @description exports all the grid data from the datasource into a csv file using ag-grid api
   */
  onBtExport() {
    const date = new Date();
    const params = {
      fileName: 'frt-comprehensive-report-' + date + '.csv',
      columnSeparator: ','
    };
    this.gridApi.exportDataAsCsv(params);
  }

  ngOnDestroy(): void {
    this.resultsSubscription.unsubscribe();
  }



}
